const projects = [
  {
    title: "OpenCanvas",
    summary: "A site for art-lovers to browse and share all types of arts.",
    description:
      "OpenCanvas: Find and read high-quality scientific articles, research papers, and compelling stories. Explore our library and expand your knowledge today.",
    technologies: [
      "Express.js",
      "JavaScript",
      "MongoDB",
      "React",
      "TailwindCSS",
    ],
    link: "https://www.opencanvas.institute",
    image: "/images/projects-imgs/opencanvas.jpeg",
  },

  {
    title: "DSA Animations",
    summary: "Data Structures and Algorithms visualiser",
    description:
      "An interactive web platform for visualizing Data Structures and Algorithms through animations. Built to make learning DSA concepts intuitive and engaging.",
    technologies: ["React", "TailwindCSS"],
    link: "https://dsa-experiments.vercel.app",
    image: "/images/projects-imgs/dsa.png",
  },

  {
    title: "SortAlgo",
    summary: "A detailed guide through sorting algorithms",
    description:
      "Interactive Blog Posts On Sorting Algorithms & Computer Science, with step by step animation, mathematical derivations.",
    technologies: ["Next.js", "Typescript", "TailwindCSS"],
    link: "https://sortalgo.space",
    image: "https://www.sortalgo.space/_next/image?url=%2Fcross.png&w=256&q=75",
  },

  {
    title: "Simulations",
    summary: "Simulations of some interesting problems.",
    description: "Simulations of some interesting problems.",
    technologies: ["Next.js", "React", "Typescript"],
    link: "https://pseudo-random.vercel.app",
    image: "https://pseudo-random.vercel.app/favicon.ico",
  },

  // {
  //   title: "markdown2pdf",
  //   summary: "Highquality markdown, latex editor and pdf converter for free",
  //   description:
  //     "webapp to edit markdown documents and latex, insert images, links. Easily export to PDF/txt/md. completely free.",
  //   technologies: ["React", "TailwindCSS", "jsPDF"],
  //   link: "https://www.opencanvas.institute/markdown2pdf",
  //   image: "/images/projects-imgs/md2pdf.jpeg",
  // },

  {
    title: "LumiFeed",
    summary: "A neat platform for reading news.",
    description:
      "A rss reader with clutterless UI to read news without advertisements, along with A.I. Summary of each news available. Many other mindblowing features available.",
    technologies: [
      "Flask",
      "postgresql",
      "sqlite",
      "React",
      "TailwindCSS",
      "Dexie.js",
      "Web Scraping",
      "AI Summary(API)",
    ],
    link: "https://lumifeed.vercel.app",
    image: "/images/projects-imgs/lumifeed.jpeg",
  },

  {
    title: "Computable Poetry",
    summary: "Bangla poem generation without Machine Learning",
    description:
      "Generating metrically correct, semantically plausible Bangla poems using formal grammars, constraint satisfaction, and graph-based planning. No machine learning anywhere in the pipeline.",
    technologies: ["python", "automata", "dijkstra", "sssp", "tagging", "nlp"],
    link: "https://computable-poetry.vercel.app",
    image: "/images/projects-imgs/graph.png",
  },

  {
    title: "Zentunes",
    summary: "Android Audio Player Application",
    description: "A music streaming platform for retro lovers.",
    technologies: ["Capacitor", "React", "SCSS"],
    link: "https://github.com/Dream-World-Coder/zentunes/tree/android-app",
    image: "/images/projects-imgs/zentunes.png",
  },

  {
    title: "EncryptEase",
    summary: "Encrypt messages or files easily.",
    description:
      "A powerful webapp to encrypt messages and files easily that are highly secure and cannot be decrypted without the encryption KEY.",
    technologies: ["Flask", "Cryptography", "AJAX"],
    link: "https://encryptease.pythonanywhere.com",
    image: "/images/projects-imgs/encryptease.jpeg",
  },

  {
    title: "Portfolio",
    summary: "This portfolio website you are visiting right now.",
    description: "A portfolio Website to easily introduce myself to everyone.",
    technologies: ["React", "TailwindCSS", "GSAP", "figma"],
    link: "https://github.com/Subha-Py-c/subhajit",
    image: "/images/projects-imgs/portfolio.jpeg",
  },

  // {
  //   title: "TithiRekha",
  //   summary: "Modern themed Bangla Calendar.",
  //   description: "A webapp to easily check bengali date and occations.",
  //   technologies: ["React", "TailwindCSS", "Web Scraping"],
  //   link: "https://bangla-calendar.vercel.app",
  //   image: "/images/projects-imgs/tithirekha.jpeg",
  // },

  {
    title: "Maze Battle Game",
    summary: "Player vs CPU maze running game",
    description: "",
    technologies: ["HTML", "CSS", "JavaScript"],
    link: "https://mazebattle.netlify.app",
    image: "/images/projects-imgs/maze-battle.jpeg",
  },
];

export default projects;
